import { EscrowStatusEnum, InvitationStatusEnum } from 'src/graphql/schema';

import { MembershipsManagementContextProvider } from '../../Management/model';
import { MembershipsManagementContainer, refetchEscrowMemberships } from '../../Management';

import AddMemberDialog from './AddMemberDialog';

type Props = {
  beneficiaryId: string;
  canAdd: boolean;
  escrowInvitationStatus?: InvitationStatusEnum;
  escrowStatus: EscrowStatusEnum;
};

const AddMemberAction = ({ beneficiaryId, canAdd, escrowInvitationStatus, escrowStatus }: Props) => {
  if (!canAdd) return null;

  const isDisabled =
    escrowInvitationStatus === InvitationStatusEnum.Rejected || escrowStatus === EscrowStatusEnum.Terminated;

  return (
    <div className="shrink-0">
      <AddMemberDialog isDisabled={isDisabled}>
        <MembershipsManagementContextProvider
          beneficiaryId={beneficiaryId}
          canCreateMember={canAdd}
          addSuccessCallback={refetchEscrowMemberships}
          removeSuccessCallback={refetchEscrowMemberships}
        >
          <MembershipsManagementContainer />
        </MembershipsManagementContextProvider>
      </AddMemberDialog>
    </div>
  );
};

export default AddMemberAction;
